import { createBrowserRouter, createHashRouter, type RouteObject } from "react-router-dom";
import Home from "./pages/home";
import ProtectRoute from "./config/routes/protect-route";
import BranchPage from "./pages/branch";
import ModelPage from "./pages/model";
import QuotationPage from "./pages/quotation";
import UserInfoPage from "./pages/userInfo";
import AccountPage from "./pages/account";
import AccountDetailPage from "./pages/account/[id]";
import BranchDetailPage from "./pages/branch/[id]";
import ModelDetailPage from "./pages/model/[id]";
import PublicOnlyRoute from "./config/routes/public-route";
import Layout from "./components/layout";
import LoginPage from "./pages/login";
import QuotationDetailPage from "./pages/quotation/[id]";
import PaymentSuccessPage from "./pages/payment/success";
import Error403 from "./pages/error/403";
import PartnerPage from "./pages/partner";
import PartnerDetailPage from "./pages/partner/[id]";

const useHash = import.meta.env.VITE_USE_HASH_ROUTER === "true";

const routes: RouteObject[] = [
  {
    element: <ProtectRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          { index: true, element: <Home /> },
          // 계정 관리
          { path: "account", element: <AccountPage /> },
          { path: "account/:id", element: <AccountDetailPage /> },
          // 업체 관리
          { path: "branch", element: <BranchPage /> },
          { path: "branch/:id", element: <BranchDetailPage /> },
          // 기종 관리
          { path: "model", element: <ModelPage /> },
          { path: "model/:id", element: <ModelDetailPage /> },
          // 시세표 관리
          { path: "quotation", element: <QuotationPage /> },
          { path: "quotation/:id", element: <QuotationDetailPage /> },
          // 제휴 관리
          { path: "partner", element: <PartnerPage /> },
          { path: "partner/quotation/:id", element: <QuotationDetailPage mode="partner" /> },
          { path: "partner/:id", element: <PartnerDetailPage /> },

          { path: "payment/success", element: <PaymentSuccessPage /> },
          // 마이페이지
          { path: "userinfo", element: <UserInfoPage /> },
          // 에러 페이지
          { path: "error/403", element: <Error403 /> },
        ]
      }
    ]
  },
  {
    element: <PublicOnlyRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: "login", element: <LoginPage /> },
        ]
      }
    ]
  },
];

export const router = useHash ? createHashRouter(routes) : createBrowserRouter(routes);